import React         from 'react';
import LocaleString       from '../../shared/locale-string/';

import './sso-error.scss';

const Error = props => (
    <div className="error-page">
        <div className="content-container">
                <div>
                    <p>
                        <LocaleString code="sso.error.login" />
                    </p>
                </div>
        </div>
    </div>
);

export default Error;
